<template>
    <div>
        <div class="con zfcg">
            <h4>政府采购</h4>
            <ul>
                <li v-for="(item,index) in zfcgList[0].children" :key="index">
                    <div 
                        class="title" 
                        @click="addZfcgPro(item)">
                            {{item.text}}
                            <el-tooltip placement="bottom" effect="light" v-if="item.url.indexOf('ext3childtype') == '-1'">
                                <div slot="content" v-html="item.content"></div>
                                <i class="el-icon-warning" style="padding-right:5px;color:#666"></i>
                            </el-tooltip>
                    </div>

                </li>
            </ul>
        </div>
        <div class="con jsgc">
            <h4>建设工程</h4>
            <ul>
                <li>
                    <div 
                        @click="addJsgcPro"
                        class="title">
                            建设工程项目
                    </div>
                </li>
                <li>
                    <div 
                        @click="addJsgczbPro"
                        class="title">
                            建设工程招标项目
                    </div>
                </li>
            </ul>
        </div>

        <my-dialog
        v-model="dialogVisible"
        :title="dialogTitle">
            <form-elec-agree
            v-if="dialogVisible"
            :row="row"
            :type="type"
            @reloadpage="$emit('reload')"
            @cancle="dialogClose">
            </form-elec-agree>
        </my-dialog>

    </div>
</template>

<script>
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import FormElecAgree from '@views/bidding/views/project/common/form'
import '../config/config.js'
export default {
    mixins: [DIALOG_LIST_PAGE_MIXIN],
    components: {FormElecAgree},
    data() {
        return {
            zfcgList:[],
            row:{},
            dialogVisible:false,
            type:'',
            dialogTitle:'',
            pathname:'',
        }
    },
    created() {
        this.zfcgList = getSession('user').proList;
        this.zfcgList[0].children.forEach(function(item){
            window.zfcgList.forEach(function(list){
                if(item.type==list.type){
                    item.content = list.content;
                }
            })
        })
    },
    methods: {
        addZfcgPro(item){
            // window.top.$tagFrame.pushTag({
            //     src:this.pathname+'?t='+Math.random()+`#/bidding/project/zfcg/form?type=`+item.type+'&isTrusted=true',
            //     title:'添加政府采购项目',
            //     type: 'href',
            //     topparent:'common-tag',
            // })
            var src = this.pathname+'?t='+Math.random()+`#/bidding/project/zfcg/form?type=`+item.type+'&isTrusted=true';
            if(item.url.indexOf('ext3childtype') != '-1'){
                src = this.pathname+'?t='+Math.random()+`#/bidding/project/zfcg/form?type=`+item.type+'&isTrusted=true&ext3childtype=' + item.url.slice(item.url.indexOf('ext3childtype') + 14);
            }
            window.top.$tagFrame.pushTag({
                src:src,
                title:'添加政府采购项目',
                type: 'href',
                topparent:'common-tag',
            })
            // this.goto({
            //     path: '/bidding/project/zfcg/form',
            //     query: {
            //         type: type,
            //         isTrusted:true,
            //     }
            // });
        },
        addJsgcPro(){
            var that = this;
            that.$get(`${that.getGetters('mngUrl')}/v2/Zbdl/ZbProject/newScPro.json`, data => {
                if(data.izBj){
                    that.ProjectEdit(data.procode)
                }else{
                    that.dialogTitle = '添加项目';
                    that.type = 'add';
                    that.dialogVisible = true;
                }
            }) 
            
        },
        addJsgczbPro(){
            window.top.$tagFrame.pushTag({
                src:`/Zbdl/ZbProject/edit`,
                title:'添加建设工程项目',
                type: 'href',
                topparent:'common-tag',
            })
        },
        ProjectEdit(procode){
            var that = this;
            that.$get(`${that.getGetters('mngUrl')}/Zbdl/Project/edit.json`,{
                id:procode,
            }, (data, res) => {
                var url = ''
                if(data['page-url']==='normal'){
                    url = 'form'
                }else if(data['page-url']==='zxsp'){
                    url = 'getproinfoForm'
                }else if(data['page-url']==='sjjt'){
                    url = 'getsjjtForm'
                }
                window.top.$tagFrame.pushTag({
                    src:this.pathname+'?t='+Math.random()+`#/bidding/project/`+url+'?id='+procode,
                    title:'添加项目',
                    type: 'href',
                    topparent:'common-tag',
                })
               
            });
        }
        
    },
    mounted(){
        this.pathname = window.location.pathname
       
    },
}
</script>

<style>
    .con h4{ font-size: 16px; }
    .con ul{ overflow: hidden; margin: 25px 0; }
    .con li{ float: left; margin-right: 5px; }
    .con li:last-child{ margin-right: 0;}
    .con li .title{ min-width:120px; height: 45px; line-height: 45px; text-align: center; background-color: #f7f1f8; cursor: pointer; padding: 0 10px; color: #AB6BBD; margin-bottom: 20px; }
    .con li p{ color: #666; text-align: center; margin-top: 10px; font-size: 12px; }
    .el-tooltip__popper{ font-size: 14px; }
    .zfcg{ border-bottom: 1px solid #ededed; margin-bottom: 25px; }
    .zfcg li .title:hover{ background-color: #AB6BBD; color: #fff; }
    .jsgc li .title:hover{ background-color: #feb64a; color: #fff; }
</style>